import { render, staticRenderFns } from "./personalRecordList.vue?vue&type=template&id=3b6562bf&scoped=true&"
import script from "./personalRecordList.vue?vue&type=script&lang=js&"
export * from "./personalRecordList.vue?vue&type=script&lang=js&"
import style0 from "./personalRecordList.vue?vue&type=style&index=0&id=3b6562bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6562bf",
  null
  
)

export default component.exports